import * as Yup from "yup";
import { FormField } from "../../common/Form";

export function RecuperaPasswordFormFields(): Array<FormField> {
  return [
    {
      id: 'email',
      label: 'Inserisci l’indirizzo email del tuo account',
      name: 'email',
      type: 'email',
      required: true,
      className: 'form-control',
      placeholder: 'Inserisci il tuo indirizzo email',
      validation: Yup.string()
        .email("Il campo deve essere un indirizzo email valido")
        .required("Campo obbligatorio"),
      description: 'Riceverai una mail in cui ti verranno date istruzioni per procedere con il recupero della password'
    },
]}